module.exports = global["tippy"] = require("-!/home/circleci/repo/node_modules/babel-loader/lib/index.js??ref--5!./tippy.min.js");